import { Component, computed, inject, input } from '@angular/core';
import { CrntButtonAlt } from '@essent/current-web-angular';
import { JssPlatformService } from '@core/jss-platform';
import {
  JssModule,
  LinkField,
  TextField,
  type RichTextField,
} from '@sitecore-jss/sitecore-jss-angular';
import { FieldService, GenericLinkDirective } from '@core/jss-utils';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { ContentSectionService } from '@core/content-section';
import { NgClass } from '@angular/common';
import { TrackLinkDirective } from '@analytics/events';

@Component({
  selector: 'wl-simple-table',
  standalone: true,
  imports: [
    JssModule,
    CrntButtonAlt,
    GenericLinkDirective,
    RichTextWrapperComponent,
    NgClass,
    TrackLinkDirective,
  ],
  templateUrl: './simple-table.component.html',
  styleUrls: [
    './simple-table.component.ed.scss',
    './simple-table.component.essent.scss',
  ],
})
export class SimpleTableComponent {
  readonly theme = inject(ContentSectionService).theme;
  readonly #jssPlatformService = inject(JssPlatformService);
  readonly #fieldService = inject(FieldService);

  readonly headingField = input.required<TextField>();
  readonly introductionField = input.required<TextField>();
  readonly tableField = input.required<RichTextField>();
  readonly button = input.required<LinkField>();

  readonly isButtonInverted = computed(
    () => this.theme() === 'Donker' || this.theme() === 'Merk'
  );

  readonly showButton = computed(() =>
    this.#fieldService.showLinkField(this.button())
  );

  readonly isEditorActive = computed(() =>
    this.#jssPlatformService.isEditorActive()
  );
}
